/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMOsisRuleListQuery
 */
export interface BCMOsisRuleListQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BCMOsisRuleListQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleListQuery
     */
    description?: string | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof BCMOsisRuleListQuery
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleListQuery
     */
    marketingCarrier?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleListQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BCMOsisRuleListQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BCMOsisRuleListQuery
     */
    limit?: number | null;
}

export function BCMOsisRuleListQueryFromJSON(json: any): BCMOsisRuleListQuery {
    return BCMOsisRuleListQueryFromJSONTyped(json, false);
}

export function BCMOsisRuleListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'marketingCarrier': !exists(json, 'marketingCarrier') ? undefined : json['marketingCarrier'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function BCMOsisRuleListQueryToJSON(value?: BCMOsisRuleListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'description': value.description,
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'showDisabled': value.showDisabled,
        'marketingCarrier': value.marketingCarrier,
        'showDeleted': value.showDeleted,
        'offset': value.offset,
        'limit': value.limit,
    };
}


